import { forwardRef, type Ref, type SVGProps } from "react";

function SvgInstantPaySmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={50} height={50} fill="none" {...props}>
      <g clipPath="url(#instant-pay-small_svg__a)">
        <circle
          cx={27.27}
          cy={22.727}
          r={22.727}
          stroke="url(#instant-pay-small_svg__b)"
          strokeWidth={9.091}
        />
      </g>
      <path
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.455}
        d="M27.273 14.422v-1.695m0 16.942v1.695m3.543-14.401c-.707-1.013-2.03-1.694-3.543-1.694h-.455c-2.008 0-3.636 1.348-3.636 3.012v.129c0 1.19.811 2.277 2.096 2.81l3.989 1.652c1.285.532 2.096 1.62 2.096 2.81 0 1.734-1.697 3.14-3.792 3.14h-.299c-1.514 0-2.836-.681-3.543-1.694"
      />
      <rect width={17.727} height={17.727} x={0.227} y={0.227} fill="#0D2B57" rx={8.864} />
      <rect
        width={17.727}
        height={17.727}
        x={0.227}
        y={0.227}
        stroke="#fff"
        strokeWidth={0.455}
        rx={8.864}
      />
      <g clipPath="url(#instant-pay-small_svg__c)">
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.455}
          d="M10.592 5.734c.2-.615-.556-1.1-.993-.607L6.219 8.93c-.345.389-.083 1.024.434 1.024H8.28c.056 0 .1.057.081.117l-.73 2.387c-.19.617.569 1.087 1 .594l3.34-3.825c.34-.39.077-1.019-.438-1.019H9.906c-.056 0-.1-.058-.08-.119z"
        />
      </g>
      <defs>
        <clipPath id="instant-pay-small_svg__a">
          <rect width={45.455} height={45.455} x={4.545} fill="#fff" rx={22.727} />
        </clipPath>
        <clipPath id="instant-pay-small_svg__c">
          <path fill="#fff" d="M4.547 4.545h9.09v9.091h-9.09z" />
        </clipPath>
        <linearGradient
          id="instant-pay-small_svg__b"
          x1={27.27}
          x2={27.27}
          y1={0}
          y2={45.455}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgInstantPaySmall);
export default ForwardRef;
